<section class="our-numbers cm-surface-box-blue-with-shapes">
  <div class="our-numbers-container">
    <h2 class="our-numbers-heading">{{ 'our-numbers.heading' | translate }}</h2>
    <div class="our-numbers-items">
      <ng-container *ngFor="let number of numbers">
        <div class="our-numbers-item">
          <div class="display-h1 flex mb-4 lg:mb-8">
            <span
              appAnimatedCounter
              class="our-numbers-value"
              [value]="number.value | translate"
              [duration]="1000"
              [startOnView]="true"
              [template]="number.template || '' | translate"
            ></span>
          </div>
          <div class="max-w-[23ch] display-paragraph-large" [innerHTML]="number.heading | translate"></div>
        </div>
      </ng-container>
    </div>
  </div>
</section>
